import React, { FC, useMemo } from 'react';
import { styled, useTheme } from '@material-ui/core';
import { startOfDay, addDays, isBefore, format, parseISO } from 'date-fns';

import { Theme } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from './FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  date: string;
  isCompleted?: boolean;
  className?: string;
};

type DeadlineWrapperProps = {
  bgcolor: string;
  color: string;
};
const DeadlineWrapper = styled('span')<Theme, DeadlineWrapperProps>(
  ({ theme, bgcolor, color }) => ({
    backgroundColor: bgcolor,
    color: color,
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.5),
    borderRadius: theme.config.defaultBorderRadius,
    fontSize: theme.typography.bodyMd.fontSize,
    '& > *:first-child': {
      marginRight: theme.spacing(1),
    },
  })
);

const TODAY = startOfDay(new Date());
const TWO_DAYS_FROM_NOW = addDays(new Date(), 2);
const FIVE_DAYS_FROM_NOW = addDays(new Date(), 5);

const Deadline: FC<Props> = ({ date, isCompleted, className }) => {
  const theme = useTheme();

  const { bgColor, color } = useMemo(() => {
    if (isCompleted) return { bgColor: 'rgb(165,190,136)', color: theme.palette.common.white };
    if (isBefore(parseISO(date), TODAY))
      return { bgColor: theme.palette.urgent.main, color: theme.palette.common.white }; //red
    if (isBefore(parseISO(date), TWO_DAYS_FROM_NOW))
      return { bgColor: 'rgb(210, 144, 0)', color: theme.palette.common.white }; //orange
    if (isBefore(parseISO(date), FIVE_DAYS_FROM_NOW))
      return { bgColor: theme.palette.warning.main, color: theme.palette.common.black }; //yellow
    return { bgColor: 'rgb(165,190,136)', color: theme.palette.common.white }; //green
  }, [date, theme, isCompleted]);

  return (
    <DeadlineWrapper className={className} bgcolor={bgColor} color={color}>
      <FontAwesomeSpriteIcon icon={SpriteIconsLight.TIMER} color="inherit" />
      {format(parseISO(date), 'd MMMM yyyy')}
    </DeadlineWrapper>
  );
};

export default Deadline;
